var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.editModal && _vm.editModal.open
        ? _c("EditOptionsModal", {
            attrs: {
              onModalClose: () => (_vm.editModal = { open: false }),
              onModalAccept: () => _vm.reloadDrug(),
              modalData: _vm.editModal,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { action: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.updateDrug.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v(_vm._s(_vm.details.drug_info?.title?.title)),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localDetails.drug_info.title.text_value,
                      expression: "localDetails.drug_info.title.text_value",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", required: "" },
                  domProps: {
                    value: _vm.localDetails.drug_info.title.text_value,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.localDetails.drug_info.title,
                        "text_value",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _vm.details.drug_info.main_word
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.details.drug_info.main_word?.title)),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.localDetails.drug_info.main_word.text_value,
                          expression:
                            "localDetails.drug_info.main_word.text_value",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { required: "", type: "text" },
                      domProps: {
                        value: _vm.localDetails.drug_info.main_word.text_value,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.localDetails.drug_info.main_word,
                            "text_value",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.details.drug_info.seo_title
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.details.drug_info.seo_title?.title)),
                    ]),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(
                        'Используйте "###" для разделения, например: ###Айрол ### Третиноин крем 0,05% 20г'
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.localDetails.drug_info.seo_title.text_value,
                          expression:
                            "localDetails.drug_info.seo_title.text_value",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: {
                        value: _vm.localDetails.drug_info.seo_title.text_value,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.localDetails.drug_info.seo_title,
                            "text_value",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.localDetails.drug_info.slug
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("ЧПУ "),
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.editAllow.slug = true
                            },
                          },
                        },
                        [_vm._v("редактировать")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localDetails.drug_info.slug.text_value,
                          expression: "localDetails.drug_info.slug.text_value",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        required: "",
                        disabled: !_vm.editAllow.slug,
                        type: "text",
                      },
                      domProps: {
                        value: _vm.localDetails.drug_info.slug.text_value,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.localDetails.drug_info.slug,
                            "text_value",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Цены")]),
                  _vm._v(" "),
                  _vm._l(_vm.drug.prices, function (price) {
                    return _c("p", [
                      _c("strong", [_vm._v(_vm._s(price.price))]),
                      _vm._v(" руб. от "),
                      _c("strong", [_vm._v(_vm._s(price.qty))]),
                      _vm._v("\n            единиц(ы)"),
                    ])
                  }),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _vm._v("\n        Допустимые параметры:\n        "),
              _vm._m(1),
              _vm._v(" "),
              _c("div", [
                _c("strong", { attrs: { for: "" } }, [
                  _vm._v(_vm._s(_vm.details.drug_meta?.title?.title)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.localDetails.use_default_meta.title.int_value,
                        expression:
                          "localDetails.use_default_meta.title.int_value",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "ch__1" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.localDetails.use_default_meta.title.int_value
                      )
                        ? _vm._i(
                            _vm.localDetails.use_default_meta.title.int_value,
                            null
                          ) > -1
                        : _vm.localDetails.use_default_meta.title.int_value,
                    },
                    on: {
                      change: function ($event) {
                        var $$a =
                            _vm.localDetails.use_default_meta.title.int_value,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.localDetails.use_default_meta.title,
                                "int_value",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.localDetails.use_default_meta.title,
                                "int_value",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.localDetails.use_default_meta.title,
                            "int_value",
                            $$c
                          )
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "ch__1" },
                    },
                    [_vm._v(_vm._s(_vm.details.use_default_meta?.title?.title))]
                  ),
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localDetails.drug_meta.title.text_value,
                      expression: "localDetails.drug_meta.title.text_value",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    disabled:
                      !!_vm.localDetails.use_default_meta?.title?.int_value,
                    rows: "2",
                  },
                  domProps: {
                    value: _vm.localDetails.drug_meta.title.text_value,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.localDetails.drug_meta.title,
                        "text_value",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("strong", { attrs: { for: "" } }, [
                  _vm._v(_vm._s(_vm.details.drug_meta.description?.title)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.localDetails.use_default_meta.description
                            .int_value,
                        expression:
                          "localDetails.use_default_meta.description.int_value",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "ch__2" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.localDetails.use_default_meta.description.int_value
                      )
                        ? _vm._i(
                            _vm.localDetails.use_default_meta.description
                              .int_value,
                            null
                          ) > -1
                        : _vm.localDetails.use_default_meta.description
                            .int_value,
                    },
                    on: {
                      change: function ($event) {
                        var $$a =
                            _vm.localDetails.use_default_meta.description
                              .int_value,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.localDetails.use_default_meta.description,
                                "int_value",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.localDetails.use_default_meta.description,
                                "int_value",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.localDetails.use_default_meta.description,
                            "int_value",
                            $$c
                          )
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "ch__2" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.details.use_default_meta.description?.title)
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localDetails.drug_meta.description.text_value,
                      expression:
                        "localDetails.drug_meta.description.text_value",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    disabled:
                      !!_vm.localDetails.use_default_meta.description.int_value,
                    rows: "3",
                  },
                  domProps: {
                    value: _vm.localDetails.drug_meta.description.text_value,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.localDetails.drug_meta.description,
                        "text_value",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("strong", [
                  _vm._v(_vm._s(_vm.details.drug_meta.keywords?.title)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.localDetails.use_default_meta.keywords.int_value,
                        expression:
                          "localDetails.use_default_meta.keywords.int_value",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "ch__3" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.localDetails.use_default_meta.keywords.int_value
                      )
                        ? _vm._i(
                            _vm.localDetails.use_default_meta.keywords
                              .int_value,
                            null
                          ) > -1
                        : _vm.localDetails.use_default_meta.keywords.int_value,
                    },
                    on: {
                      change: function ($event) {
                        var $$a =
                            _vm.localDetails.use_default_meta.keywords
                              .int_value,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.localDetails.use_default_meta.keywords,
                                "int_value",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.localDetails.use_default_meta.keywords,
                                "int_value",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.localDetails.use_default_meta.keywords,
                            "int_value",
                            $$c
                          )
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "ch__3" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.details.use_default_meta.keywords?.title)
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localDetails.drug_meta.keywords.text_value,
                      expression: "localDetails.drug_meta.keywords.text_value",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    disabled:
                      !!_vm.localDetails.use_default_meta.keywords.int_value,
                    rows: "2",
                  },
                  domProps: {
                    value: _vm.localDetails.drug_meta.keywords.text_value,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.localDetails.drug_meta.keywords,
                        "text_value",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "mb-2" }, [
                _c("h5", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.details.drug_info.description?.title)),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text_editor_500" },
                  [
                    _c("textEditor", {
                      attrs: { editor: _vm.ckEditor, config: _vm.ckConfig },
                      model: {
                        value:
                          _vm.localDetails.drug_info.description.text_value,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.localDetails.drug_info.description,
                            "text_value",
                            $$v
                          )
                        },
                        expression:
                          "localDetails.drug_info.description.text_value",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-2" }, [
                _c("h5", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.details.instruction.text?.title)),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text_editor_500" },
                  [
                    _c("textEditor", {
                      attrs: { editor: _vm.ckEditor, config: _vm.ckConfig },
                      model: {
                        value: _vm.localDetails.instruction.text.text_value,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.localDetails.instruction.text,
                            "text_value",
                            $$v
                          )
                        },
                        expression: "localDetails.instruction.text.text_value",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.details.drug_info.registration
                ? _c("div", { staticClass: "mb-2" }, [
                    _c("h5", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.details.drug_info.registration?.title)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text_editor_500" },
                      [
                        _c("textEditor", {
                          attrs: { editor: _vm.ckEditor, config: {} },
                          model: {
                            value:
                              _vm.localDetails.drug_info.registration
                                .text_value,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localDetails.drug_info.registration,
                                "text_value",
                                $$v
                              )
                            },
                            expression:
                              "localDetails.drug_info.registration.text_value",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "mt-4 mb-3" },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("EgkSelect", {
                      ref: "egkCode",
                      attrs: {
                        updateDetail: (code) => (_vm.selectedEgkCode = code),
                      },
                    }),
                    _vm._v(" "),
                    _vm.selectedEgkCode
                      ? _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.selectedEgkCode?.title) +
                              " (" +
                              _vm._s(_vm.selectedEgkCode.id) +
                              ")\n            "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-hover table-sm mt-2" },
                  [
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.details.options, function (opt, key, i) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(opt?.title))]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              opt.options && opt.options.length
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex justify-content-between",
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _vm.localDetails.options[key]
                                              .selected
                                              ? [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options:
                                                        _vm.getSortedArray(
                                                          opt.options
                                                        ),
                                                      placeholder:
                                                        "Выберите данные",
                                                      "track-by": "title",
                                                      label: "title",
                                                      "allow-empty": true,
                                                      showLabels: true,
                                                      searchable: true,
                                                      multiple:
                                                        _vm.localDetails
                                                          .options[key]
                                                          .multiple,
                                                    },
                                                    on: {
                                                      input: (e) =>
                                                        _vm.selectOption(
                                                          e,
                                                          key
                                                        ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.localDetails
                                                          .options[key]
                                                          .selected,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.localDetails
                                                            .options[key],
                                                          "selected",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "localDetails.options[key].selected",
                                                    },
                                                  }),
                                                ]
                                              : [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.localDetails
                                                              .options[key][
                                                              opt.type +
                                                                "_value"
                                                            ],
                                                          expression:
                                                            "localDetails.options[key][opt.type+'_value']",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            _vm.localDetails
                                                              .options[key],
                                                            opt.type + "_value",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    _vm._l(
                                                      opt.options,
                                                      function (option) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                (option &&
                                                                  option.id) ||
                                                                (option &&
                                                                  option.value) ||
                                                                (option &&
                                                                  option.name) ||
                                                                option,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  option.name ||
                                                                    option.text ||
                                                                    option
                                                                ) +
                                                                "\n                          "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _vm.localDetails.options[key]
                                              .selected
                                              ? [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-outline-info ml-1",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.editOptions(
                                                            key,
                                                            opt.options
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          Редактировать\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ]
                                : [
                                    opt.type === "array"
                                      ? [
                                          !_vm.localDetails?.options?.[key]
                                            ? [
                                                _c("p", [
                                                  _vm._v(
                                                    "no localDetails[options][" +
                                                      _vm._s(key) +
                                                      "]]!"
                                                  ),
                                                ]),
                                              ]
                                            : [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.localDetails
                                                          .options[key][
                                                          "text_value"
                                                        ],
                                                      expression:
                                                        "localDetails.options[key]['text_value']",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value:
                                                      _vm.localDetails.options[
                                                        key
                                                      ]["text_value"],
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.localDetails
                                                          .options[key],
                                                        "text_value",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                        ]
                                      : [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.localDetails.options[key][
                                                    opt.type + "_value"
                                                  ],
                                                expression:
                                                  "localDetails.options[key][opt.type+'_value']",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: {
                                              value:
                                                _vm.localDetails.options[key][
                                                  opt.type + "_value"
                                                ],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.localDetails.options[key],
                                                  opt.type + "_value",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-info btn-sm",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openCopyDetail(opt.id)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "icon-fa icon-fa-copy" })]
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "alert alert-info mb-1" }, [
                _vm._v(
                  "\n          На сайте, препараты из дочерних категорий также отображаются в родительских категориях\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "div",
                    [
                      _c("strong", [_vm._v("Рубрика")]),
                      _vm._v(" "),
                      _c("multiselect", {
                        attrs: {
                          options: _vm.siteCategories ?? [],
                          placeholder: "Выберите категорию",
                          "track-by": "name",
                          label: "name",
                          showLabels: false,
                          searchable: true,
                          multiple: true,
                        },
                        on: { input: _vm.selectCategory },
                        model: {
                          value: _vm.selectedCategories,
                          callback: function ($$v) {
                            _vm.selectedCategories = $$v
                          },
                          expression: "selectedCategories",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.details.extra.dosage_page
                    ? _c(
                        "div",
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.details.extra?.dosage_page?.title)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            attrs: {
                              options:
                                _vm.details.extra.dosage_page?.options ?? [],
                              placeholder: "Выберите группу",
                              "track-by": "name",
                              label: "name",
                              showLabels: false,
                              searchable: true,
                              multiple: false,
                            },
                            on: {
                              input: (e) =>
                                _vm.updateSelectData("extra", "dosage_page", e),
                            },
                            model: {
                              value:
                                _vm.localDetails.extra.dosage_page.selected,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.localDetails.extra.dosage_page,
                                  "selected",
                                  $$v
                                )
                              },
                              expression:
                                "localDetails.extra.dosage_page.selected",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.authors && _vm.details.authors.id
                    ? _c(
                        "div",
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.details.authors.id.title)),
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            attrs: {
                              options: _vm.details.authors.id?.options ?? [],
                              placeholder: "Выберите автора",
                              "track-by": "name",
                              label: "name",
                              showLabels: false,
                              searchable: true,
                              multiple: false,
                            },
                            on: {
                              input: (e) =>
                                _vm.updateSelectData("authors", "id", e),
                            },
                            model: {
                              value: _vm.localDetails.authors.id.selected,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.localDetails.authors.id,
                                  "selected",
                                  $$v
                                )
                              },
                              expression: "localDetails.authors.id.selected",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _vm.details.extra && _vm.details.extra.analogs
                      ? [
                          _c("strong", [_vm._v("Аналоги")]),
                          _vm._v(" "),
                          _c("DrugSearchNew", {
                            attrs: {
                              onSelect: (drug) => _vm.addDrugToAnalog(drug),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "analog_drug_selector flex flex-wrap mt-1",
                            },
                            _vm._l(_vm.analogDrugs, function (drug) {
                              return _c("span", [
                                _vm._v(
                                  _vm._s(drug?.title) + "\n                  "
                                ),
                                _c("i", {
                                  staticClass: "icon-fa icon-fa-remove pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeAnalogDrug(drug.id)
                                    },
                                  },
                                }),
                              ])
                            }),
                            0
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.details.extra && _vm.details.extra.analogs_table
                      ? _c(
                          "div",
                          [
                            _c("strong", [
                              _vm._v(
                                "Аналоги для таблицы (код вставки в редактор - %%%analogs_table%%%)"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("DrugSearchNew", {
                              attrs: {
                                onSelect: (drug) =>
                                  _vm.addDrugToAnalog(drug, "analogs_table"),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "analog_drug_selector flex flex-wrap mt-1",
                              },
                              _vm._l(_vm.analogTableDrugs, function (drug) {
                                return _c("span", [
                                  _vm._v(
                                    _vm._s(drug?.title) + "\n                  "
                                  ),
                                  _c("i", {
                                    staticClass:
                                      "icon-fa icon-fa-remove pointer",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeAnalogDrug(
                                          drug.id,
                                          "analogs_table"
                                        )
                                      },
                                    },
                                  }),
                                ])
                              }),
                              0
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    0 &&
                    _vm.details.extra &&
                    _vm.details.extra.analogs_table_display
                      ? _c("div", [
                          _c("div", { staticClass: "form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.localDetails.extra.analogs_table_display
                                      .int_value,
                                  expression:
                                    "localDetails.extra.analogs_table_display.int_value",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: { type: "checkbox", id: "ch__11" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.localDetails.extra.analogs_table_display
                                    .int_value
                                )
                                  ? _vm._i(
                                      _vm.localDetails.extra
                                        .analogs_table_display.int_value,
                                      null
                                    ) > -1
                                  : _vm.localDetails.extra.analogs_table_display
                                      .int_value,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.localDetails.extra
                                        .analogs_table_display.int_value,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.localDetails.extra
                                            .analogs_table_display,
                                          "int_value",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.localDetails.extra
                                            .analogs_table_display,
                                          "int_value",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.localDetails.extra
                                        .analogs_table_display,
                                      "int_value",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "ch__11" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.details.extra.analogs_table_display
                                      ?.title
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.details.extra && _vm.details.extra.other_form
                      ? _c(
                          "div",
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.details.extra.other_form?.title)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("DrugSearchNew", {
                              attrs: { onSelect: _vm.addDrugToOtherForm },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "analog_drug_selector flex flex-wrap mt-1",
                              },
                              _vm._l(_vm.otherForms, function (drug) {
                                return _c("span", [
                                  _vm._v(
                                    _vm._s(drug?.title) + "\n                  "
                                  ),
                                  _c("i", {
                                    staticClass:
                                      "icon-fa icon-fa-remove pointer",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeOtherFormDrug(drug.id)
                                      },
                                    },
                                  }),
                                ])
                              }),
                              0
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "flex-grow-1" }, [
                  _c("strong", [
                    _vm._v(
                      "Применяется при болезнях и симптомах: (через запятую)"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.localDetails.extra.symptoms.text_value,
                        expression: "localDetails.extra.symptoms.text_value",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { rows: "2" },
                    domProps: {
                      value: _vm.localDetails.extra.symptoms.text_value,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.localDetails.extra.symptoms,
                          "text_value",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex align-items-end" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ml-1 btn btn-outline-info btn-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.openCopyDetail(
                            _vm.localDetails.extra.symptoms.detail_id
                          )
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon-fa icon-fa-copy" })]
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.details.extra && _vm.details.extra.no_certificates
            ? _c("div", { staticClass: "card" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.localDetails.extra.no_certificates.int_value,
                          expression:
                            "localDetails.extra.no_certificates.int_value",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: "ch__10" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.localDetails.extra.no_certificates.int_value
                        )
                          ? _vm._i(
                              _vm.localDetails.extra.no_certificates.int_value,
                              null
                            ) > -1
                          : _vm.localDetails.extra.no_certificates.int_value,
                      },
                      on: {
                        change: function ($event) {
                          var $$a =
                              _vm.localDetails.extra.no_certificates.int_value,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.localDetails.extra.no_certificates,
                                  "int_value",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.localDetails.extra.no_certificates,
                                  "int_value",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.localDetails.extra.no_certificates,
                              "int_value",
                              $$c
                            )
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "ch__10" },
                      },
                      [_vm._v(_vm._s(_vm.details.extra.no_certificates?.title))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "mt-1 mb-1" },
                      [
                        _vm._m(7),
                        _vm._v(" "),
                        _c(
                          "draggable",
                          {
                            staticClass: "flex flex-wrap",
                            attrs: { tag: "div" },
                            model: {
                              value: _vm.certificatesFiles,
                              callback: function ($$v) {
                                _vm.certificatesFiles = $$v
                              },
                              expression: "certificatesFiles",
                            },
                          },
                          _vm._l(_vm.certificatesFiles, function (img, i) {
                            return !img.to_delete
                              ? _c("div", { key: i, staticClass: "img_div" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-danger btn-xs",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeFile(i)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-trash",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "imagePreviewWrapper",
                                    attrs: { src: img.source, alt: "" },
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: img.name,
                                        expression: "img.name",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Имя файла",
                                    },
                                    domProps: { value: img.name },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          img,
                                          "name",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ])
                              : _vm._e()
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(8),
                    _vm._v(" "),
                    _c("input", {
                      ref: "file",
                      staticClass: "hidden",
                      attrs: {
                        type: "file",
                        id: "filesUpload",
                        accept: "image/x-png,image/gif,image/jpeg",
                        multiple: "multiple",
                      },
                      on: { change: _vm.readMultiFiles },
                    }),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.details.videos
            ? _c("div", { staticClass: "card" }, [
                _vm._m(9),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _vm._l(_vm.videos, function (video, index) {
                      return _c("VideoItem", {
                        key: `video-` + index,
                        attrs: {
                          index: index,
                          video: video,
                          deleteVideo: _vm.deleteVideo,
                        },
                      })
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: { click: _vm.addVideo },
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-plus" }),
                        _vm._v(" Добавить видео"),
                      ]
                    ),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-body text-right" },
              [
                _c("LoadingButton", {
                  attrs: {
                    title: "Сохранить препарат",
                    type: "submit",
                    className: "btn btn-success",
                    onClick: () => {},
                    loading: _vm.loading,
                    color: "white",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Meta Tags")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [_vm._v("%%%name%%% - название препарата")]),
      _vm._v(" "),
      _c("li", [_vm._v("%%%price%%% - цена препарата")]),
      _vm._v(" "),
      _c("li", [_vm._v("%%%veschestvo%%% - действующее вещество")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "%%%morph_1-4%%% - морфрологические названия города (пример: Иркутск, Иркутске, Иркутска, Иркутску)\n          "
        ),
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("%%%city_phone%%% - телефон города")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Описание товара")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [_c("strong", [_vm._v("Проверка активности ЕГК")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [_c("strong", [_vm._v("Список переменных в описании:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Ключ")]),
        _vm._v(" "),
        _c("th", [_vm._v("Значение")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Сертификаты")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [
        _vm._v(
          "Для смены порядка отображение сертификатов, перетащите их в желаемой\n              последовательности"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "filesUpload" } }, [
      _c(
        "span",
        { staticClass: "btn btn-outline-info", attrs: { type: "button" } },
        [_vm._v("Загрузить файлы")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Видео")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }